import { Component, JSX } from "react";
import { AccuracyBandEnum, AccuracyInspectionIconEnum } from "@app/projects/enumerators";
import { TooltipWrapper } from "@app/shared";
import { AccuracyTemplateScoringBand, PointStyle } from "@app/templates/accuracy";
import { valueOrDashes } from "./provider-inspection-profile-components/utils";

interface AccuracyInspectionIconProps {
  accuracyTemplateScoringBands: AccuracyTemplateScoringBand[];
  inspectionName: string;
  maxPoints: number;
  pointStyle: string;
  result?: string;
  resultJustification?: string;
  bandOverride?: AccuracyBandEnum;
  score: number;
  weight: number;
  filterResult: boolean;
}

export default class AccuracyInspectionIcon extends Component<AccuracyInspectionIconProps, unknown> {

  constructor(props: AccuracyInspectionIconProps) {
    super(props);
  }

  public render(): JSX.Element {
    const isProviderClaimsActivity = this.props.inspectionName === "Provider Claims Activity";
    const isPracAtLocConfidence = this.props.inspectionName === "Practitioner At Location Confidence";

    return (
      <TooltipWrapper
        delay={200}
        text={isProviderClaimsActivity || isPracAtLocConfidence ? '' : this.getIconToolTip()}
        position="bottom"
      >
        {isProviderClaimsActivity || isPracAtLocConfidence
            ? <div className="text-left"> {!this.props.filterResult ? valueOrDashes(this.props.result) : ''}</div>
            :
            <i
              className={`fa fa-${this.getInspectionIcon()}`}
              style={{ color: this.getBandColor() }}
            />
        }

      </TooltipWrapper>
    );
  }

  private getIconToolTip = () => {
    let content;
    if (this.props.bandOverride?.toUpperCase() == AccuracyBandEnum.Enriched.toUpperCase()) {
      return "Enriched";
    }
    if (isNaN(this.props.score)) {
      return "Skipped";
    } else {
      content = (
        <div>
          <div className="d-inline-block text-right pr-2">
            Score:
            <br />
            Weight:
            {this.props.resultJustification && (
              <>
                <br />
                Result:
                <br />
                Justification:
              </>
            )}
          </div>
          <div className="d-inline-block">
            {this.props.score}
            <br />
            {this.props.weight}
            {this.props.resultJustification && (
              <>
                <br />
                {this.props.result}
                <br />
                {this.props.resultJustification}
              </>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="accuracy-tooltip-legend">
        <div>
          {this.props.inspectionName}
        </div>
        <hr />
        <div>
          {content}
        </div>
      </div>
    );
  }

  private getInspectionIcon = () => {
    if (this.props.bandOverride?.toUpperCase() == AccuracyBandEnum.Enriched.toUpperCase()) {
      return AccuracyInspectionIconEnum.Star;
    }
    if (isNaN(this.props.score)) {
      return AccuracyInspectionIconEnum.Ban;
    }
    if (this.props.pointStyle.toUpperCase() === PointStyle.Unknown.toUpperCase()) {
      return AccuracyInspectionIconEnum.Question;
    }
    if (this.props.pointStyle.toUpperCase() === PointStyle.Bad.toUpperCase()) {
      return this.props.score === 0
        ? AccuracyInspectionIconEnum.Check
        : AccuracyInspectionIconEnum.Times;
    } else if (this.props.pointStyle.toUpperCase() === PointStyle.Good.toUpperCase()) {
      return this.props.score === this.props.maxPoints
        ? AccuracyInspectionIconEnum.Check
        : AccuracyInspectionIconEnum.Times;
    }
  }

  private getBandColor = () => {
    if (this.props.bandOverride?.toUpperCase() == AccuracyBandEnum.Enriched.toUpperCase()) {
      return "#056EDF";
    } else if (isNaN(this.props.score)) {
      return this.props.accuracyTemplateScoringBands.find((b) => b.name.toUpperCase() == AccuracyBandEnum.Skipped.toUpperCase()).bandColor;
    }
    return this.props.accuracyTemplateScoringBands.find((b) => b.range.minPoints <= this.props.score && this.props.score <= b.range.maxPoints).bandColor;
  }
}
